import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

let cacheByUserId = new Map();
let inflightByUserId = new Map();

/**
 * Funcionalidades do usuário logado (cache em memória, zera no F5).
 */
export const getPermissao = async () => {
  try {
    const usuarioLogado = sso.getUsuarioLogado();
    const userId = usuarioLogado.id;

    const cached = cacheByUserId.get(userId);
    if (cached && Date.now() - cached.timestamp < CACHE_TTL_MS) {
      return cached.funcionalidades;
    }

    if (inflightByUserId.has(userId)) {
      return inflightByUserId.get(userId);
    }

    const promise = (async () => {
      try {
        const response = await api.get(`usuario/${userId}/funcionalidades`);
        const funcionalidades = response.data.funcionalidade_id;
        cacheByUserId.set(userId, {
          timestamp: Date.now(),
          funcionalidades,
        });
        return funcionalidades;
      } finally {
        inflightByUserId.delete(userId);
      }
    })();

    inflightByUserId.set(userId, promise);
    return promise;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.error("Erro ao obter permissões", error);
    return [];
  }
};
